<template>
    <div class="driver-upload">
        <h2>1. Upload a csv</h2>
        <div>
            <p>Name the upload:</p>
            <div class="cd-section">
                <input type="text" class="form-control" v-model="name"></input>
            </div>
        </div>
        <driver-upload-file @uploadFinished="(d) => dataLoaded(d.data)"></driver-upload-file>

        <div v-if="step >= 2">
            <h2>2. Map csv fields to our database</h2>
            <div class="table-responsive" v-if="file_data">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th v-for="header in file_data.header">{{ header }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td v-for="header in file_data.header">
                            <select class="form-control" style="min-width: 200px;" v-model="mapping[header]">
                                <option :value="null">---</option>
                                <option v-for="o in options" :value="o.id">{{ o.name }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr v-for="line in file_data.lines">
                        <td v-for="entry in line">{{ entry }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="validation_errors" style="margin-top: 30px">
                <div v-for="message in validation_errors" class="alert alert-danger">{{ message }}</div>
            </div>

            <h2>3. Date fields</h2>
            <div>
                <p>The dates above mean:</p>
                <div class="cd-section">
                    <el-radio label="hire" v-model="date_meaning">Hire date (the day the driver was hired)</el-radio>
                </div>
                <div class="cd-section">
                    <el-radio label="application" v-model="date_meaning">Lead date (the day the driver submitted a short form app with us)
                    </el-radio>
                </div>
                <div class="cd-section">
                    <el-radio label="none" v-model="date_meaning">No dates in the file above</el-radio>
                </div>
            </div>

            <div style="text-align: center; margin-top: 50px;">
                <btn cssClass="btn-primary btn-lg" icon="fas fa-cloud-upload-alt" :disabled="validation_errors.length > 0" :click="matchDrivers">Match Drivers</btn>

                <div style="margin: 20px;" v-if="chunks > 0">
                    Uploading: {{ percent(chunks_processed/chunks) }}. Please wait
                </div>
            </div>
        </div>

        <div v-if="step >= 3">
            <h2>4. Action</h2>
            <div>
                <div class="cd-section">
                    <el-radio label="hire" v-model="action">Hire Validation</el-radio>
                </div>
                <div class="cd-section">
                    <el-radio label="lead" v-model="action">Lead Validation</el-radio>
                </div>

                <validation-action v-if="action == 'hire'" :driver_upload_id="this.driver_upload_id"
                                   :employer_id="this.employer_id"></validation-action>
                <validation-lead-action v-if="action == 'lead'" :driver_upload_id="this.driver_upload_id"
                                        :employer_id="this.employer_id"></validation-lead-action>
            </div>
        </div>
    </div>
</template>

<script>
import DriverUploadFile from "./driver-upload-file";
import ValidationAction from "../../../delivery/ValidationHire/vue/validation-action";
import ValidationLeadAction from "../../../delivery/ValidationLead/vue/validation-lead-action";

export default {
    components: {ValidationLeadAction, ValidationAction, DriverUploadFile},
    props: [
        'employer_id'
    ],
    data() {
        let options = [
            {id: 'year', 'name': 'Year (eg. 2021)'},
            {id: 'month', 'name': 'Month (eg. 5 or May)'},
            {id: 'week', 'name': 'Week (eg. 27)'},
            {id: 'date', 'name': 'Date (eg. 2021-07-12)'},
            {id: 'first_name', 'name': 'First Name'},
            {id: 'last_name', 'name': 'Last Name'},
            {id: 'name', 'name': 'Name'},
            {id: 'phone', 'name': 'Phone'},
            {id: 'email', 'name': 'Email'},
            {id: 'status', 'name': 'Status'},
            {id: 'cdl_xp_months', 'name': 'CDL XP in Months'},
            {id: 'notes', 'name': 'Notes'},
            {id: 'zip_code', 'name': 'Zip Code'},
        ];

        return {
            'step': 1,
            'file_data': {header: [], lines: []},
            'name': '',
            'options': options,
            'mapping': {},
            'date_meaning': null,
            'driver_upload_id': null,
            'action': null,

            'chunks': 0,
            'chunks_processed': 0,
            validation_errors: [],

            pusher: {
                all_users: null,
            },
        };
    },
    computed: {},
    watch: {
        date_meaning() {
            this.validateMapping();
        },
        mapping: {
            handler: function () { this.validateMapping(); },
            deep: true
        }
    },
    methods: {
        dataLoaded(data) {
            this.file_data = data;
            this.mapping = data.suggestions;
            this.step = 2;

            if (this.name === '') {
                let file_name = data.upload_name;
                this.name = file_name.substring(0, file_name.lastIndexOf('.'));
            }

            if (Array.isArray(this.mapping) && this.mapping.length === 0) {
                this.mapping = {};
            }
        },
        validateMapping() {
            this.validation_errors = [];
            if (!_.find(this.mapping, (type) => type === 'phone') && !_.find(this.mapping, (type) => type === 'email')) {
                this.validation_errors.push("A 'Phone' or 'Email' column is missing in the mapping. Please select at least one 'Phone' or 'Email' column in step 2.");
            }
            if (['hire', 'application'].includes(this.date_meaning)
                && !(
                    _.find(this.mapping, (type) => type === 'date')
                    || (_.find(this.mapping, (type) => type === 'year') 
                        && (
                            _.find(this.mapping, (type) => type === 'month')
                            || _.find(this.mapping, (type) => type === 'week')
                        )
                    )
                )
            ) {
                this.validation_errors.push("A 'Date' column is missing in the mapping. Please select at least one 'Date' column or 'Year+Month/Week' columns in step 2 or select 'No dates' in step 3.");
            }
            return true;
        },
        matchDrivers() {
            return axios.post(url(`admin/driver-upload/process`), {
                'mapping': this.mapping,
                'employer_id': this.employer_id,
                'name': this.name,
                'file_id': this.file_data.file_id,
                'file_name': this.file_data.upload_name,
                'date_fields_meaning': this.date_meaning
            }).then((response) => {
                this.driver_upload_id = response.data.driver_upload.id;
                this.chunks = response.data.chunks;
                this.chunks_processed = 0;
            });
        },
        driversMatched() {
            this.step = 3;
        }
    },
    created() {
        this.pusher.all_users = Echo.private(`jb-all-users`);
        this.pusher.all_users.listen('.driver-upload-done', (event) => {
            if (event.update_id == this.driver_upload_id) {
                this.driversMatched();
            }
        });
        this.pusher.all_users.listen('.driver-upload-progress', (event) => {
            if (event.update_id == this.driver_upload_id) {
                this.chunks_processed++;
            }
        });
    },
    beforeDestroy() {
        this.pusher.all_users.stopListening('.driver-upload-done');
        this.pusher.all_users.stopListening('.driver-upload-progress');
    }
}
</script>

<style>
.driver-upload h2 {
    margin-top: 60px;
}

.driver-upload h2:first-child {
    margin-top: 20px;
}
</style>
